import React, { useEffect, useState, useCallback } from "react";
import {useFormContext } from "react-hook-form";
import FormInput from "../../form-components/InputComponent";
import { Button } from "../../../components/Component";
import { Row, Col } from "reactstrap";
import FormSelect from "../../form-components/SelectComponent";
import usersApis from "../../../api/master/users";
import sites from "../../../api/master/sites";
import sequenceApis from "../../../api/master/sequence";
import Swal from "sweetalert2";
import GstinVerificationModal from "../../../components/GstinVerificationModal";
import FormDatePicker from "../../form-components/DatePicker";
interface SelectOptions {
  label: string;
  value: string;
}
const ClientInformation = (props: any) => {
  const {
      register,
      handleSubmit,
      setValue,
      formState: { errors },
      watch,
      reset,
      trigger,
      getValues,
      clearErrors,
    } = useFormContext();

  const [gstinModal, setGstinModal] = useState(false);
  const [states, setStates] = useState<SelectOptions[]>([]);
  const [districtOptions, setDistrictOptions] = useState<SelectOptions[]>([]);
  const [countries, setCountries] = useState<SelectOptions[]>([]);
  const [workingSites, setWorkingSites] = useState<any>([]);
  const [previousBusinessType, setPreviousBusinessType] = useState<string>("");
  const [isSettingGstData, setIsSettingGstData] = useState(false);
  const [gstVerificationCancelled, setGstVerificationCancelled] = useState(false);
  const [isSequenceActive, setIsSequenceActive] = useState(false);

  const businessType = watch("bussinessType");
  const countryWatch = watch("country");
  const stateWatch = watch("state");

  const fetchSequenceStatus = async () => {
    try {
      const response = await sequenceApis.fetchSequenceByModuleId(166);
      const { data } = response;
      const today = new Date();
      // Check if sequence exists with:
      // 1. moduleId === 166 (Clients)
      // 2. status === "Active" (if "Active", hide Client ID field)
      // 3. endDate is in the future
      const _sequenceAccess = data?.filter(
        (item: any) =>
          item.moduleId === 166 &&
          item.status === "Active" &&
          new Date(item.endDate) > today
      );
      setIsSequenceActive(_sequenceAccess && _sequenceAccess.length > 0);
    } catch (error: any) {
      console.log(error.response?.data?.message || "An error occurred");
      setIsSequenceActive(false);
    }
  };

  useEffect(() => {
    if (countryWatch) {
      fetchStatesByCountry(countryWatch);
    }
  }, [countryWatch]);
  useEffect(() => {
    if (stateWatch) {
      getDistricts(stateWatch);
    }
  }, [stateWatch]);
  useEffect(() => {
    getCountries();
    fetchWorkingSites();
    fetchStatesByCountry("1");
    fetchSequenceStatus();
  }, []);
  useEffect(() => {
    if (businessType === "registered") {
      setValue("applicationAccess", "true");
    }
  }, [businessType, setValue]);

  useEffect(() => {
    if (previousBusinessType && previousBusinessType !== businessType) {
      // Only reset GST-related fields, not all fields
      resetGstRelatedFields();
      setGstVerificationCancelled(false);
    }
    setPreviousBusinessType(businessType);
  }, [businessType]);

  const resetGstRelatedFields = () => {
    clearErrors();
    // Only reset GST-specific fields
    const gstFieldsToReset = [
      "gstin",
      "cin",
      "incorporationDate",
      "pan",
      "companyName",
      "country",
      "state",
      "district",
      "city",
      "area",
      "mailingAddressLine1",
      "pincode",
      "lastFYTurnover",
      "applicationAccess",
    ];

    gstFieldsToReset.forEach((field) => {
      setValue(field, "", { shouldValidate: false });
    });

    if (businessType === "registered") {
      setValue("applicationAccess", "true", { shouldValidate: false });
    } else {
      setValue("applicationAccess", "", { shouldValidate: false });
    }
  };

  const isGstVerified = () => {
    const values = getValues();
    return !!values.gstin && !!values.pan;
  };

  useEffect(() => {
    if (businessType === "registered" && !isGstVerified()) {
      setGstinModal(true);
      setGstVerificationCancelled(false);
    } else {
      setGstinModal(false);
    }
  }, [businessType]);

  const fetchWorkingSites = async (selectedOptions: SelectOptions[] = []) => {
    try {
      const { data, status, message } = await sites.fetchSites();
      if (status) {
        setWorkingSites(
          data.map((item: any) => ({
            label: item.name,
            value: item.siteID?.toString(),
          }))
        );
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (err: any) {
      Swal.fire("Error", err.message, "error");
    }
  };

  const getCountries = async () => {
    try {
      const _countries = await usersApis.getCountrys();
      if (_countries.status) {
        if (_countries.data.length > 0) {
          const transformedData = _countries.data.map((item: any) => ({
            value: item.countryId.toString(),
            label: item.countryName,
          }));
          setCountries(transformedData);
        }
      }
    } catch (error: any) {
      console.log(error.message);
    }
  };

  const fetchStatesByCountry = async (countryId: string) => {
    try {
      const data = await usersApis.getStatesByCountry(countryId);
      const stateOptions = data?.data?.map((state: any) => ({
        value: state.stateId.toString(),
        label: state.stateName,
      }));
      if (stateOptions.length > 0) setStates(stateOptions);
    } catch (error) {}
  };
  const getDistricts = async (stateID: any) => {
    try {
      const districts = await usersApis.getDistrictsByState(stateID);
      console.log(districts);
      if (districts.status) {
        if (districts.data.length > 0) {
          const transformedData = districts.data.map((item: any) => ({
            value: item.districtId.toString(),
            label: item.districtName,
          }));
          setDistrictOptions(transformedData);
        }
      }
    } catch (error: any) {
      console.log(error.message);
    }
  };
  const submitForm = (data: any) => {
    console.log("General Info Data:", data);
    props.next();
  };

  const findOptionValue = (label: string, options: SelectOptions[]) => {
    const found = options.find((option) => option.label === label);
    return found ? found.value : "";
  };

  const handleGSTVerification = async (gstData: any) => {
    console.log("Verified GST Data:", gstData);

    setIsSettingGstData(true);
    setGstVerificationCancelled(false);
    clearErrors();

    // Set all values first without validation
    const updates = [
      () => setValue("gstin", gstData.gstin || "", { shouldValidate: false }),
      () => setValue("pan", gstData.pan || "", { shouldValidate: false }),
      () =>
        setValue("companyName", gstData.LegalName || "", {
          shouldValidate: false,
        }),
      () =>
        setValue("country", findOptionValue(gstData.country, countries) || "", {
          shouldValidate: false,
        }),
      () =>
        setValue("state", findOptionValue(gstData.state, states) || "", {
          shouldValidate: false,
        }),
      () =>
        setValue(
          "district",
          findOptionValue(gstData.district, districtOptions) || "",
          { shouldValidate: false }
        ),
      () => setValue("city", gstData.city || "", { shouldValidate: false }),
      () => setValue("area", gstData.area || "", { shouldValidate: false }),
      () =>
        setValue("mailingAddressLine1", gstData.addressLine1 || "", {
          shouldValidate: false,
        }),
      () =>
        setValue("pincode", gstData.zipPincode || "", {
          shouldValidate: false,
        }),
    ];

    // Execute all setValue calls
    updates.forEach((update) => update());

    // Wait for React to process the state updates
    setTimeout(() => {
      // Trigger validation for all relevant fields
      const fieldsToValidate = [
        "gstin",
        "pan",
        "companyName",
        "country",
        "state",
        "district",
        "city",
        "area",
        "mailingAddressLine1",
        "pincode",
      ];

      trigger(fieldsToValidate).then((isValid) => {
        console.log("Validation result after GST data:", isValid);
        setIsSettingGstData(false);
      });
    }, 300);
  };

  return (
    <>
      <form className="content clearfix" onSubmit={handleSubmit(submitForm)}>
        <h5 className="mb-2">Legal Information</h5>
        <Row className="gy-4">
          <Col md="3">
            <FormSelect
              name="bussinessType"
              label="Business Type"
              required={true}
              options={[
                { label: "Registered", value: "registered" },
                { label: "Unregistered", value: "unregistered" },
              ]}
              placeholder="Select Business Type"
            />
          </Col>
          {/* Conditional Fields */}
          {businessType === "registered" && (
            <>
              <Col md="3">
                <FormInput
                  name="gstin"
                  label="GSTIN"
                  required
                  type="text"
                  placeholder="Auto-filled GSTIN"
                  disabled={!gstVerificationCancelled || isGstVerified()}
                />
              </Col>

              <Col md="3">
                <FormInput
                  name="cin"
                  label="CIN"
                  type="text"
                />
              </Col>

              <Col md="3">
                <FormDatePicker
                  name="incorporationDate"
                  label="Incorporation Date"
                  required
                />
              </Col>

              <Col md="3">
                <FormInput
                  name="lastFYTurnover"
                  label="Last FY Turn Over (INR)"
                  type="text"
                  placeholder="Enter Last FY Turnover"
                  pattern={/^\d+$/}
                />
              </Col>
            </>
          )}
          {(businessType === "registered" ||
            businessType === "unregistered") && (
            <Col md="3">
              <FormInput
                name="pan"
                label="PAN"
                required
                type="text"
                pattern={/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/}
                placeholder={
                  businessType === "registered"
                    ? "Auto-filled PAN"
                    : "Enter PAN"
                }
                disabled={businessType === "registered" && (!gstVerificationCancelled || isGstVerified())}
              />
            </Col>
          )}

          {businessType === "unregistered" && (
            <Col md="3">
              <FormInput
                name="cin"
                label="CIN"
                type="text"
                placeholder="Enter CIN"
              />
            </Col>
          )}
        </Row>

        <h5 className="mt-4 mb-2">General Information</h5>
        <Row className="gy-4">
          {!isSequenceActive && (
            <Col md="3">
              <FormInput
                name="referenceID"
                label="Client ID"
                type="text"
                pattern={/^[a-zA-Z0-9./_-]+$/}
                required={true}
                placeholder="Enter Client ID"
              />
            </Col>
          )}
          <Col lg="3">
            <FormSelect
              name="contractorType"
              label="Client Type"
              required={true}
              options={[
                { label: "General Client", value: "General Client" },
                { label: "Sub Client", value: "Sub Client" },
                { label: "Self Construction", value: "Self Construction" },
              ]}
              placeholder="Enter Client Terms"
            />
          </Col>
          <Col lg="3">
            <FormInput
              name="companyName"
              label="Client Name"
              required={true}
              placeholder="Enter Client Name"
              pattern={/^[A-Za-z\s.&/-]+$/}
              onInput={(e: any) => {
                e.target.value = e.target.value.replace(/[^A-Za-z\s.&/-]/g, ""); // Removes invalid characters
              }}
              disabled={businessType === "registered"}
            />
          </Col>
          <Col lg="3">
            <FormSelect
              name="country"
              label="Country"
              options={countries}
              required={true}
              placeholder="-Select-"
            />
          </Col>
          <Col md="3">
            <FormSelect
              name="state"
              label="State"
              required={true}
              options={states}
              placeholder="Select State"
            />
          </Col>
          <Col md="3">
            <FormSelect
              name="district"
              label="District"
              options={districtOptions}
              required={true}
              placeholder="Select District"
            />
          </Col>
          <Col md="3">
            <FormInput
              name="city"
              label="City"
              required={true}
              placeholder="Enter City"
              type="text"
            />
          </Col>
          <Col lg="3">
            <FormInput
              name="area"
              label="Area"
              required={true}
              placeholder="Enter Area"
            />
          </Col>
          <Col md="3">
            <FormInput
              name="mailingAddressLine1"
              label="Address Line 1"
              required={true}
              placeholder="Enter Area"
            />
          </Col>
          <Col md="3">
            <FormInput
              name="pincode"
              label="Zip/Pincode"
              required={true}
              type="text"
              pattern={/^\d+$/} // Allows only digits
              onInput={(e: any) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Removes non-numeric characters
              }}
              placeholder="Enter Zip or pin code"
            />
          </Col>
          <Col md="3">
            <FormInput
              name="yearsInBusiness"
              label="Years in Business"
              type="text"
              placeholder="Enter Years in Business"
              pattern={/^\d+$/} // Allows only digits
              onInput={(e: any) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Removes non-numeric characters
              }}
            />
          </Col>
          <Col md="3">
            <FormSelect
              name="applicationAccess"
              label="Application Access"
              required={true}
              options={[
                { label: "Yes", value: "true" },
                { label: "No", value: "false" },
              ]}
              placeholder="Select Access"
            />
          </Col>
        </Row>
        <Row className="gy-4 mt-1">
          <Col>
            <Button color="primary" type="submit">
              Next
            </Button>
          </Col>
        </Row>
      </form>
      <GstinVerificationModal
        isOpen={gstinModal}
        toggle={() => {
          setGstinModal(!gstinModal);
          if (gstinModal && !isGstVerified()) {
            setGstVerificationCancelled(true);
          }
        }}
        onVerified={handleGSTVerification}
        countries={countries}
        states={states}
        districts={districtOptions}
        source="clients"
      />
    </>
  );
};

export default React.memo(ClientInformation);
